/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phase_1_Task_Check_ForestInputs */

const en_phase_1_task_check_forest = /** @type {(inputs: Phase_1_Task_Check_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See your effort in your forest`)
};

const ar_phase_1_task_check_forest = /** @type {(inputs: Phase_1_Task_Check_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شاهد ثمرة جهدك في غابتك`)
};

const de_phase_1_task_check_forest = /** @type {(inputs: Phase_1_Task_Check_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sehen Sie Ihre Bemühungen in Ihrem Wald`)
};

const es_phase_1_task_check_forest = /** @type {(inputs: Phase_1_Task_Check_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observa tu esfuerzo en tu bosque`)
};

const fr_phase_1_task_check_forest = /** @type {(inputs: Phase_1_Task_Check_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admirez vos efforts dans votre forêt`)
};

const it_phase_1_task_check_forest = /** @type {(inputs: Phase_1_Task_Check_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guarda i tuoi sforzi nella tua foresta`)
};

const ja_phase_1_task_check_forest = /** @type {(inputs: Phase_1_Task_Check_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分の森で努力の成果をチェック`)
};

const ko_phase_1_task_check_forest = /** @type {(inputs: Phase_1_Task_Check_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 숲에서 노력의 결실 확인하기`)
};

const pt_br_phase_1_task_check_forest = /** @type {(inputs: Phase_1_Task_Check_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veja seus esforços na sua floresta`)
};

const ru_phase_1_task_check_forest = /** @type {(inputs: Phase_1_Task_Check_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посмотрите на свои усилия в своём лесу`)
};

const th_phase_1_task_check_forest = /** @type {(inputs: Phase_1_Task_Check_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูความพยายามของคุณในป่า`)
};

const tr_phase_1_task_check_forest = /** @type {(inputs: Phase_1_Task_Check_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ormanında emeklerini gör`)
};

const zh_cn_phase_1_task_check_forest = /** @type {(inputs: Phase_1_Task_Check_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在你的森林欣赏成果`)
};

const zh_tw_phase_1_task_check_forest = /** @type {(inputs: Phase_1_Task_Check_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在你的森林欣賞成果`)
};

/**
* | output |
* | --- |
* | "See your effort in your forest" |
*
* @param {Phase_1_Task_Check_ForestInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const phase_1_task_check_forest = /** @type {((inputs?: Phase_1_Task_Check_ForestInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase_1_Task_Check_ForestInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_phase_1_task_check_forest(inputs)
	if (locale === "ar") return ar_phase_1_task_check_forest(inputs)
	if (locale === "de") return de_phase_1_task_check_forest(inputs)
	if (locale === "es") return es_phase_1_task_check_forest(inputs)
	if (locale === "fr") return fr_phase_1_task_check_forest(inputs)
	if (locale === "it") return it_phase_1_task_check_forest(inputs)
	if (locale === "ja") return ja_phase_1_task_check_forest(inputs)
	if (locale === "ko") return ko_phase_1_task_check_forest(inputs)
	if (locale === "pt_br") return pt_br_phase_1_task_check_forest(inputs)
	if (locale === "ru") return ru_phase_1_task_check_forest(inputs)
	if (locale === "th") return th_phase_1_task_check_forest(inputs)
	if (locale === "tr") return tr_phase_1_task_check_forest(inputs)
	if (locale === "zh_cn") return zh_cn_phase_1_task_check_forest(inputs)
	return zh_tw_phase_1_task_check_forest(inputs)
});